import { createContext, useReducer, useEffect } from "react";
import { projectAuth } from "../firebase/config";
import { DateTime } from "luxon";
import {
  utilGetDocumentFilters,
  utilGetCollectionFilterReference,
} from "../util/UtilsFirebase";
export const AuthContext = createContext();
export const authReducer = (state, action) => {
  switch (action.type) {
    case "LOGIN":
      return {
        ...state,
        user: action.payload,
        register: action.register,
        employee: action.employee,
      };
    case "LOGOUT":
      return { ...state, user: null, register: null, employee: null };
    case "AUTH_IS_READY":
      return {
        ...state,
        user: action.payload,
        authIsReady: true,
        register: action.register,
        employee: action.employee,
      };
    case "UPDATE_REGISTER":
      return { ...state, register: action.payload, employee: action.employee };
    default:
      return state;
  }
};
export const AuthContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, {
    user: null,
    authIsReady: false,
    register: null,
    szoneNeg: "none",
    employee: null,
  });

  useEffect(() => {
    let isFirstTime = true;
    const unsub = projectAuth.onAuthStateChanged(async (user) => {
      if (isFirstTime) {
        if (user) {
          const registros = await utilGetCollectionFilterReference(
            "registro",
            "user",
            "==",
            user.uid,
            "users"
          );
          var registro = null;
          if (registros.length > 0) {
            registro = registros[0].data();
            registro.id = registros[0].id;
          } else {
            var empleado = null;
            const localTimeZone = "America/Hermosillo";
            const currentDate = DateTime.now().setZone(localTimeZone);
            const startOfDay = currentDate.startOf("day");
            let filtros = [
              { campo: "user", operador: "==", valor: user.uid },
              {
                campo: "start_date",
                operador: ">=",
                valor: startOfDay.toJSDate(),
              },
            ];
            const checador = await utilGetDocumentFilters("checador", filtros);
            empleado = null;
            if (checador && checador.length > 0 && !checador[0].end_date) {
              let filtros1 = [
                { campo: "id_usuario", operador: "==", valor: user.uid },
                {
                  campo: "id_puesto",
                  operador: "==",
                  valor: checador[0].puesto,
                },
              ];
              const empleados = await utilGetDocumentFilters(
                "personal",
                filtros1
              );
              if (empleados && empleados.length !== 0) {
                empleado = empleados[0];
                empleado.id = empleados[0].id;
                const filtros = [
                  { campo: "id", operador: "==", valor: empleado["id_puesto"] },
                ];
                const registros = await utilGetDocumentFilters(
                  "registro",
                  filtros
                );
                registro = null;
                if (registros[0] !== undefined) {
                  registro = registros[0];
                  registro.id = registros[0].id;
                }
              } else {
                alert(
                  "No se ha registrado la entrada del empleado, por favor registre su entrada en el negocio"
                );
                projectAuth.signOut();
                user = null;
              }
            } else {
              let filtros1 = [
                { campo: "id_usuario", operador: "==", valor: user.uid },
              ];
              const empleados = await utilGetDocumentFilters(
                "personal",
                filtros1
              );
              if (empleados && empleados.length !== 0) {
                alert(
                  "No se ha registrado la entrada del empleado, por favor registre su entrada en el negocio"
                );
                projectAuth.signOut();
                user = null;
              }
            }
          }
          //console.log(registro)
        }
        dispatch({
          type: "AUTH_IS_READY",
          payload: user,
          register: registro,
          employee: empleado,
        });
        isFirstTime = false;
        return;
      }
      if (user) {
        const registros = await utilGetCollectionFilterReference(
          "registro",
          "user",
          "==",
          user.uid,
          "users"
        );
        registro = null;
        if (registros.length > 0) {
          registro = registros[0].data();
          registro.id = registros[0].id;
        } else {
          empleado = null;
          const localTimeZone = "America/Hermosillo";
          const currentDate = DateTime.now().setZone(localTimeZone);
          const startOfDay = currentDate.startOf("day");
          let filtros = [
            { campo: "user", operador: "==", valor: user.uid },
            {
              campo: "start_date",
              operador: ">=",
              valor: startOfDay.toJSDate(),
            },
          ];
          const checador = await utilGetDocumentFilters("checador", filtros);
          empleado = null;
          if (checador && checador.length > 0 && !checador[0].end_date) {
            let filtros1 = [
              { campo: "id_usuario", operador: "==", valor: user.uid },
              {
                campo: "id_puesto",
                operador: "==",
                valor: checador[0].puesto,
              },
            ];
            const empleados = await utilGetDocumentFilters(
              "personal",
              filtros1
            );
            if (empleados && empleados.length !== 0) {
              empleado = empleados[0];
              empleado.id = empleados[0].id;
              const filtros = [
                { campo: "id", operador: "==", valor: empleado["id_puesto"] },
              ];
              const registros = await utilGetDocumentFilters(
                "registro",
                filtros
              );
              registro = null;
              if (registros[0] !== undefined) {
                registro = registros[0];
                registro.id = registros[0].id;
              }
            } else {
              alert(
                "No se ha registrado la entrada del empleado, por favor registre su entrada en el negocio"
              );
              projectAuth.signOut();
              user = null;
            }
          } else {
            let filtros1 = [
              { campo: "id_usuario", operador: "==", valor: user.uid },
            ];
            const empleados = await utilGetDocumentFilters(
              "personal",
              filtros1
            );
            if (empleados && empleados.length !== 0) {
              alert(
                "No se ha registrado la entrada del empleado, por favor registre su entrada en el negocio"
              );
              projectAuth.signOut();
              user = null;
            }
          }
        }
        dispatch({
          type: "LOGIN",
          payload: user,
          register: registro,
          employee: empleado,
        });
      } else {
        dispatch({ type: "LOGOUT" });
      }
    });
    return () => {
      unsub();
    };
  }, []);
  const setRegister = (registerValue) => {
    dispatch({ type: "UPDATE_REGISTER", payload: registerValue });
  };
  return (
    <AuthContext.Provider value={{ ...state, dispatch, setRegister }}>
      {children}
    </AuthContext.Provider>
  );
};
